import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { validatePipeline as restValidatePipeline } from '~/api/runtimeService';

type ValidatePipelineVariables = {
  realm: string;
  pipelineId: string;
  environment: string;
};

export const useValidatePipeline = () => {
  const queryClient = useQueryClient();

  const validatePipeline = useCallback(
    (variables: ValidatePipelineVariables) =>
      queryClient.fetchQuery({
        queryKey: [
          'run',
          'validatePipeline',
          variables.realm,
          variables.pipelineId,
          variables.environment
        ],
        queryFn: () => restValidatePipeline(variables),
        staleTime: 0,
        gcTime: 0
      }),
    [queryClient]
  );

  return { validatePipeline };
};
